import React from 'react';
import * as DateFns from 'date-fns';

import {
  DEFAULT_WEEK_COMPARE_TO_DATA,
  LABEL_DEFAULT_DAYS_COMPARE_TO_DATA,
  SCOPE
} from '../../../../../config/constants';
import { DefaultPropsType } from '../types';

const DateRangeSelectorDefault = ({ newData, setNewData, changeViewMonths, now, specificScope }: DefaultPropsType) => {
  return (
    <div className="calendar-h">
      {LABEL_DEFAULT_DAYS_COMPARE_TO_DATA.map((data, index) => (
        <div className={`radio ll-oo`} key={data.label + index}>
          <input
            id={`radio-default-${data.days}`}
            name="radio-default-date-range-compare"
            type="radio"
            checked={newData.default === data.days}
            onChange={() => {
              setNewData({
                ...newData,
                selectedDates: [{
                  start: specificScope === SCOPE.DATAOPS.PAGE ? DateFns.subDays(now, data.days - 1) : DateFns.subDays(now, data.days),
                  end: specificScope === SCOPE.DATAOPS.PAGE ? now as Date : DateFns.subDays(now, 1)
                }],
                default: data.days,
                year: 'Select',
                week: DEFAULT_WEEK_COMPARE_TO_DATA,
                threshold: 'Select'
              });
              changeViewMonths(DateFns.subDays(now, LABEL_DEFAULT_DAYS_COMPARE_TO_DATA[LABEL_DEFAULT_DAYS_COMPARE_TO_DATA.length - 1].days));
            }}
          />
          <label
            htmlFor={`radio-default-${data.days}`}
            className={`radio-label ${newData.default === data.days ? 'label-bold' : ''}`}
          >
            {data.label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default DateRangeSelectorDefault;